(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/models/news-article.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/models/news-article.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport.news.models.NewsArticle = Backbone.Model.extend({
    initialize: function() {
      this.set('ageInMinutes', this.ageInMinutes());
      return this;
    },

    ageInMinutes: function() {
      return moment
        .duration(moment().diff(moment(this.get('published'))))
        .asMinutes();
    },

    parse: function(data) {
      var el = document.createElement('div');
      el.innerHTML = data.body;
      el = svs.utils.text.matchText(el, / /g, function(
        node,
        match
      ) {
        var span = document.createElement('span');
        span.className = 'content-space';
        span.textContent = match;
        return span;
      });
      data.body = el.innerHTML;

      return data;
    }
  });
})(Backbone, _, svs);

 })(window);